import { Button, CircularProgress } from '@mui/material';
import { ReactElement, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';

import { loginRequest } from './AADProvider';
import { AuthenticationService } from 'services/AuthenticationService';
import Utils from 'shared/helpers/Utils';
import { AuthActions } from 'state/authentication/Action';
import { useDispatch } from 'react-redux';
import { useEmailValidation } from './EmailValidation';
import { EMP_ROLES } from 'state/authentication/Reducer';
import jwt_decode from 'jwt-decode';

export const AzureButton = (props: {
  title: string;
  onClick: () => void;
  isLoading: boolean;
  loadingText: string;
  disabled: boolean;
}): ReactElement => {
  const { title, onClick, isLoading, loadingText, disabled } = props;

  return (
    <Button
      disabled={disabled}
      fullWidth
      style={{
        background: '#0078d4',
        color: 'white',
      }}
      onClick={() => {
        onClick();
      }}
      size="large"
    >
      {isLoading && (
        <>
          <CircularProgress sx={{ color: 'white' }} size={25} />
          {(loadingText === '' || loadingText) && <span>{loadingText}</span>}
          {loadingText !== '' && !loadingText && <span>PROCESSING</span>}
        </>
      )}
      {!isLoading && (
        <svg
          viewBox="0 0 23 23"
          style={{
            width: 20,
            marginRight: 10,
          }}
        >
          <rect x="1" y="1" width="10" height="10" fill="#f25022" />
          <rect x="12" y="1" width="10" height="10" fill="#7fba00" />
          <rect x="1" y="12" width="10" height="10" fill="#00a4ef" />
          <rect x="12" y="12" width="10" height="10" fill="#ffb900" />
        </svg>
      )}
      {!isLoading && <>{title}</>}
    </Button>
  );
};
const AzureLoginForm = (props: any): ReactElement => {
  const {
    setEnabledMethods,
  }: {
    setEnabledMethods: any;
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { instance } = useMsal();

  const { validateEmail, validationBackendError } = useEmailValidation();

  const handleLogin = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const result = await instance.loginPopup(loginRequest);

      await instance.handleRedirectPromise();
      if (result.account && validateEmail(result.account.username) === '') {
        AuthenticationService.ssoLogin({
          token: result.idToken,
          idp: 'azure',
        })
          .then((response: any) => {
            const { data } = response.data;
            const { accessToken, twoFactor, email } = data;

            if (twoFactor?.isEnabled) {
              setEnabledMethods({
                methods: twoFactor?.enabledMethods,
                email,
              });
              dispatch(
                AuthActions.setLoginStatus({
                  twoFactor,
                })
              );
            } else {
              const decoded: any = jwt_decode(accessToken);
              dispatch(
                AuthActions.setLoginStatus({
                  accessToken,
                  isUserLoggedIn: true,
                  isOrgSelected: false,
                  ...decoded,
                  role: EMP_ROLES.Admin,
                  twoFactor,
                })
              );
              navigate('/orgs', { replace: true });
            }
          })
          .catch((error: any) => {
            validationBackendError(error);
            Utils.handleErrorResponse(error);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        setIsLoading(false);
      }
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AzureButton
        title="Login with Microsoft"
        onClick={handleLogin}
        loadingText=""
        isLoading={isLoading}
        disabled={isLoading}
      />
      {/* {emailAddress.length > 0 && (
        <EmailValidation
          showLoading={fetchingEmailConfig}
          onClose={() => {
            setRedirectUrl('');
          }}
          email={emailAddress}
          redirectURL={redirectUrl}
        />
      )} */}
    </>
  );
};

export default AzureLoginForm;
